import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { InlineSearchEventEmit, TabActionButtonConfig, TabButtonAction, Tabs, TabsConfig } from './tabs.interface';

@Component({
  selector: 'Tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TabsComponent implements OnInit, OnChanges {

  @Input() tabs: Tabs[];
  @Input() config: TabsConfig;
  @Input() currentActiveTab?: string;

  @Output() selectedTab = new EventEmitter<string>();
  @Output() buttonAction = new EventEmitter<TabButtonAction>();
  @Output() searchAction = new EventEmitter<InlineSearchEventEmit>();

  activeTab: string;
  showActionButton: boolean = false;
  buttonConfig: TabActionButtonConfig;
  searchKey: string = '';

  constructor() { }

  ngOnInit(): void {
    if(this.currentActiveTab){
      this.activeTab = this.currentActiveTab;
    }else{
      this.activeTab = this.tabs[0]?.dataKey;
    }
    this.showActionButton = this.config?.showActionButton;
    this.buttonConfig = this.config?.buttonConfig;
  }

  activateTab(tab): void{
    if(tab?.isDisabled){
      return;
    }
    this.activeTab = tab?.dataKey;
    this.selectedTab.emit(this.activeTab);
  }

  handleButtonClick(): void{
    if(!this.buttonConfig?.isDisabled){
      this.buttonAction.emit({
        type:'BUTTON',
        value: true
      });
    }
  };

  optionClick(option): void{
    this.buttonAction.emit({
      type:'OPTION',
      value: option
    });
  }

  triggerSearch(searchTerm): void{
    this.searchAction.emit({
      searchValue: searchTerm
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if('currentActiveTab' in changes){
      this.activeTab = changes.currentActiveTab.currentValue;
    }
    if('config' in changes){
      this.config = changes.config.currentValue;
      this.showActionButton = this.config?.showActionButton;
      this.buttonConfig = this.config?.buttonConfig;
    }
    if('tabs' in changes){
      this.tabs = changes.tabs.currentValue;
      this.tabs = this.tabs.map((tab) => {
        return {
          ...tab,
          isEnabled: tab?.isEnabled ?? true
        };
      });
    }
  }
}
